import Speech from '@javascripts/speech.js'

import WebCamera from 'webcamjs'
const store = {
    namespaced: true,
    state: {
        is_setting: false,
        is_keydown: true,

        /*
         * ========================================================================
         * 設定區
         * ========================================================================
         */
        config: {
            theme: {}, // 主題顏色等
            settings: {}, // 可使用的設定
            setting_groups: {}, // 可使用的設定包
        },
        // 設定包
        current_weight: 0,
        current_setting_group: {},
        setting_groups: {},
        quick_setting_regexps: {
            group: /@@(search|any_number_to_label|package|unpackage|distributed_to|pack_house_waybill|pack_waybill_goods|LA[0-9]+|LB[0-9]+|LA[0-9]+_\D+|LB[0-9]+_\D+)@@/i,
            barcode: /####(LA[0-9]+)####|####(LB[0-9]+)####/i,
            mode: /##(\w+_mode)_(true|false|min_card|card|detail|Master|House|Waybill|Goods|Package)##/i,
            package: /###(Master|House|Waybill|Goods|Package)_to_(Master|House|Waybill|Goods|Package)_([0-1])([0-1])###/i,
            // 一般設定 true|false
            // 運單卡片顯示 min_card|card|detail
            // 包裝 包材與設定 Master|House|Waybill|Goods|Package
            // 包裝進階設定 A包B 並看尾數10 第一個數字：套用資料 第二個數字：合併資料
        },
        // 細部設定
        settings: {
            is_scan_mode: true, // 掃描 or 手動模式
            is_scan_action_mode: false, // 操作模式

            is_batch_mode: false, // 批次處理模式，此模式須已逗號區隔號碼，打開後不驗證必填欄位
            is_operation_mode: true, // 使用訂單模式
            is_core_waybill_pieces_mode: true, // 多件一單模式，如：50隻筆同一個運單號
            is_core_waybill_creation_mode: false,
            is_update_core_waybill_mode: false, // 更新運單
            is_auto_print_label_mode: false, // 自動列印
            is_print_small_label_of_any_number_mode: false, // 列印小標且不管任何號碼
            is_reload_core_waybill_mode: false, // 重載CoreWaybill
            is_distributed_to_mode: false, // 分撥模式
            // is_high_performance_mode: false, // 高低效能

            // 媒體相關
            is_noty_audio_mode: false, // 提示音
            is_speech_mode: false, // 語音報件
            is_webcam_mode: false, // 鏡頭

            // 不顯示, 有必填欄位才顯示
            is_quick_corewaybill_related_columns_mode: false, // 必填資料快速套用

            // 包裝，包材 與 包裝目標 相關
            is_package_mode: false, // 自動包裝模式
            is_unpackage_mode: false, // 自動拆包裝模式

            is_pack_need_source_mode: false,
            is_pack_need_merge_mode: false,
            pack_target_parent_mode: "", // 1
            pack_target_mode: "", // 2  1包2

            // 運單樣式
            core_waybill_template_mode: 'card',
        },

        /*
         * ========================================================================
         * 必要流程
         * ========================================================================
         */

        core_waybills: [],
        current_core_waybill: {},
        current_core_waybill_scope: "",

        scan_action_prototypes: [],
        current_scan_action_prototype: {
            name: null,
            identity: null
        },
        partitions: [],
        current_partition: {},
        jobs: [],
        current_job: {},
        current_number: "",
        // Job example
        // {
        //     id: 1
        //     number: "123"
        //     core_waybill: {},
        //     scan_action_prototype: {},
        //     status: "Pending",
        //     errors: []
        // }

        /*
         * ========================================================================
         * 運單 必填欄位區
         * ========================================================================
         */

        // 最終確定資料, 顯示於alert中
        // in .components/provider/core_waybill/related_columns_alert.vue
        actions_core_waybill_related_columns: {},
        alert_core_waybill_related_columns_focus_input_name: "",

        // 顯示於 快速套用div
        // in .components/provider/core_waybill/quick_related_columns.vue
        quick_core_waybill_related_columns: {},

        /*
         * ========================================================================
         * 運單 多件一單
         *     當setting.is_core_waybill_pieces_mode == true 才會做事
         * ========================================================================
         */
        core_waybill_counters: [],

        /*
         * ========================================================================
         * 訂單區
         * ========================================================================
         */
        // 全由 provider/store 掌控

        /*
         * ========================================================================
         * 包裝 拆包區
         * ========================================================================
         */
        current_pack_taget_parent_material_identity: "",
        current_pack_taget_material_identity: "",
        package_response_history: [],
        package_message: {
            status: "failure",
            content: "",
        },
        package: {
            // 有填時，表示將core_waybill_identities包裹到它之下
            // 沒填時，表示將core_waybill_identities拆包（不在任何包內)
            // core_waybill_identities: [],

            // 上層包裝用的core_waybill, 當你是運單包子單時, 此參數必填
            source_core_waybill_identity: null,

            // 自用
            core_waybills: [],
            parent_core_waybill: {},
            difference_log: []
        },

        /*
         * ========================================================================
         * 分撥區
         * ========================================================================
         */
        distributed_to: {},

        /*
         * ========================================================================
         * 貨況備註
         * 當 current_scan_action_prototype.description_options 和 description_required_scope
         * 與 點貨模式 成立時 必填
         * ========================================================================
         */
        scan_action_description: "",

        /*
         * ========================================================================
         * 物料
         * ========================================================================
         */
        materials: [],
        webcam_snaps: [],
        webcam_snap_interval: null
    },
    getters: {
        // 判斷該 setting 是否可以使用, 因每個node 的 service_name 的Scanner settings 不同
        is_can_use_setting(state, getters, rootState, rootGetters) {
            return (value = false) => {
                if (!value) return false

                let result = _.findLast(state.config.settings, (name) => {
                    return name == value
                })

                return (result) ? true : false
            }
        },
        // 取得當前 staff 的 operation
        current_staff_operation_customer(state, getters, rootState, rootGetters) {
            if (!rootState.provider.current_staff_operation) {
                return {}
            } else {
                return rootState.provider.current_staff_operation.customer || {}
            }
        },
        // 取得當前 被包裝 的 material
        current_pack_taget_parent_material(state, getters, rootState, rootGetters) {
            return _.findLast(state.materials, (material) => {
                return material.identity == state.current_pack_taget_parent_material_identity
            }) || {}
        },
        // 取得當前 包裝 的 material
        current_pack_taget_material(state, getters, rootState, rootGetters) {
            return _.findLast(state.materials, (material) => {
                return material.identity == state.current_pack_taget_material_identity
            }) || {}
        },
        // 取得當前的 SAP 的描述
        current_scan_action_prototype_description_required_scope(state, getters, rootState, rootGetters) {
            return (state.current_scan_action_prototype.identity)
                ? state.current_scan_action_prototype.description_required_scope
                : []
        },
        // 取得當前的 SAP 的必填欄位
        current_scan_action_prototype_related_columns(state, getters, rootState, rootGetters) {
            return (state.current_scan_action_prototype.identity)
                ? state.current_scan_action_prototype.related_columns
                : []
        },
        // 確認 運單 使否需要跳出必填欄位的 Alert 視窗,
        // 取得當前 運單 需要填寫的必填欄位
        current_core_waybill_need_related_columns(state, getters, rootState, rootGetters) {
            let related_columns = $.extend(true, [], getters.current_scan_action_prototype_related_columns)

            // Scanner 批次處理模式
            if (state.settings.is_batch_mode) {
                return []
            }
            // 沒有必填欄位
            if (!related_columns.length) {
                return []
            }
            // 當前的設定不是加貨況的情況
            if (!state.current_setting_group.barcode.match(/(LA[0-9]+)|(LB[0-9]+)/i)) {
                return []
            }

            // 移除當前 運單 的 source_core_waybill 已經有值的欄位
            if (state.current_core_waybill.source_core_waybill) {
                _.remove(related_columns, (related_column) => {
                    return state.current_core_waybill.source_core_waybill[related_column.name]
                })
            }

            // 移除當前 運單 已經有值的欄位
            _.remove(related_columns, (related_column) => {
                return state.current_core_waybill[related_column.name]
            })

            // 如果當前的 運單 有 material
            if (state.current_core_waybill.material) {
                // 移除 material 不同的 必填欄位
                // 如果必填欄位內要要求的material 為null 代表不管何種 運單 都要寫
                _.remove(related_columns, (related_column) => {
                    if (!related_column.material_class_name) return false
                    return state.current_core_waybill.material.class_name != related_column.material_class_name
                })
            }

            // 如果有啟用 快速套用 模式
            if (state.settings.is_quick_corewaybill_related_columns_mode) {
                // 移除 快速套用區 已經填過的
                _.remove(related_columns, (related_column) => {
                    return state.quick_core_waybill_related_columns[related_column.name]
                })
            }

            // 如果有選訂單，且訂單內有對應的預設值，將訂單內有對應的預設值 給予 需要的必填欄位
            // 但還是會跳出 Alert 視窗給操作者確認
            if (getters.current_staff_operation_customer) {
                let key_name = ""
                _.forEach(related_columns, (related_column) => {
                    key_name = 'default_'+related_column.name
                    if (getters.current_staff_operation_customer[key_name]) {
                        state.actions_core_waybill_related_columns[related_column.name] = getters.current_staff_operation_customer[key_name]
                    }
                })
            }

            return related_columns
        },
    },
    actions: {
        fetch_scan_action_prototypes(context, payload) {
            let rest_url = new RestUrl(context.rootState.provider.routes.api_v1_provider_scan_action_prototypes)
            let url = rest_url.parse(
                {},
                ""
            )

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    context.commit('set_scan_action_prototypes', _.sortBy(response.data.scan_action_prototypes, 'barcode'))
                })
                .catch(error => {
                    console.log('Failed to fetch ScanActionPrototypes.')
                })
        },
        fetch_materials(context, payload) {
            let url = new RestUrl(context.rootState.provider.routes.api_v1_provider_materials).parse(
                {},
                ""
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        context.commit('set_materials', response.data.materials)
                    }
                })
                .catch(error => {
                    // that.errors.push("抓取物料失敗連線異常: " + error.response.status)
                    that.errors.push(
                        that.$t('ui.notifications.error.fetch__name', {
                            name: that.$t('models.materials'),
                            reason: ': ' + that.$t('ui.general.network_abnormality') + ',' + error.response.status
                        })
                    )
                    return Promise.reject(error)
                })
        },
        fetch_partitions(context, payload) {
            let url = new RestUrl(context.rootState.provider.routes.api_v1_provider_partitions).parse(
                {},
                ""
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        context.commit('set_partitions', response.data.partitions)
                    }
                })
                .catch(error => {
                    // that.errors.push("抓取物料失敗連線異常: " + error.response.status)
                    that.errors.push(
                        that.$t('ui.notifications.error.fetch__name', {
                            name: that.$t('models.partitions'),
                            reason: ': ' + that.$t('ui.general.network_abnormality') + ',' + error.response.status
                        })
                    )
                    return Promise.reject(error)
                })
        },
        update_core_waybill(context, payload) {
            // let related_columns = context.state.actions_core_waybill_related_columns
            let url = new RestUrl(context.rootState.provider.routes.api_v1_provider_core_waybill_update).parse(
                {
                    core_waybill_identity: payload.core_waybill_identity || context.state.current_core_waybill.identity,
                }
            )

            return axios.post(url, payload,
                {
                    headers: { Authorization: localStorage.getItem("authentication_token") }
                }
            )
            .then(response => {
                if (response.data.status == "success") {
                    context.commit('set_actions_core_waybill_related_columns', {})
                } else {
                    return Promise.reject("failed_to_update_core_waybill_related_column")
                }
            })
        },
        enqueue(context, payload) {
            let is_quick_setting_number = false
            _.forEach(context.state.quick_setting_regexps, (regexp) => {
                if (payload.number.match(regexp))
                    is_quick_setting_number = true
            })

            if (is_quick_setting_number) {
                return Promise.reject("quick_setting")
            } else {
                let job = {
                    id: context.state.jobs.slice(-1).pop() ? context.state.jobs.slice(-1).pop().id + 1:1,
                    task: payload.task,
                    number: payload.number,
                    original_number: payload.original_number,
                    partition: payload.partition,
                    station: payload.station,
                    core_waybill: {},
                    core_waybill_scope: "",
                    scan_action_prototype: payload.scan_action_prototype,
                    status: "Pending",
                    is_waiting_user_action: false,
                    is_batch_mode: context.state.settings.is_batch_mode,
                    errors: []
                }
                context.commit('add_job', job)
                return Promise.resolve()
            }
        },
        async perform(context, payload) {
            payload.status = "Processing"

            try {
                await context.dispatch("perform_init", payload)
                if (context.state.settings.is_print_small_label_of_any_number_mode) {
                    await context.dispatch("create_fake_core_waybill", payload)

                } else if (context.state.settings.is_core_waybill_creation_mode) {
                    await context.dispatch("search_or_create_core_waybill", payload)

                } else {
                    await context.dispatch("search_core_waybill", payload)
                }
                await context.dispatch("handle_search_result", payload)
                await context.dispatch("speech_consignee_info", payload)
                switch (payload.task) {
                    case "operation":
                        await context.dispatch("pack", payload)
                        await context.dispatch("unpack", payload)
                        await context.dispatch("check_core_waybill_related_columns", payload)
                        if (context.state.settings.is_webcam_mode) {
                            await context.dispatch("snap_webcam", payload)
                        }
                        await context.dispatch("instantiate_scan_action_prototype", payload)
                        await context.dispatch("reload_core_waybill", payload)
                        await context.dispatch("add_core_waybills_to_operation", payload)
                        await context.dispatch("fetch_statuses", payload)
                        await context.dispatch("distribute", payload)
                        payload.status = "Success"
                        break

                    case "search":
                        await context.dispatch("pack", payload)
                        await context.dispatch("unpack", payload)
                        await context.dispatch("distribute", payload)
                        payload.status = "Success"
                        break

                    case "print_label":
                        payload.status = "Success"
                        break

                    default:
                        payload.status = "Failure"
                        // await context.dispatch("set_local_storage_job")
                        return Promise.reject("task_not_found")
                }
                // await context.dispatch("set_local_storage_job")

            } catch (e) {
                // switch (e) {
                //     case "quick_setting_not_found":
                //     case "core_waybill_not_found":
                //     case "no_input_number":
                //     case "current_scan_action_prototype_identity":
                //     case "failed_to_instantiate_scan_action_prototype":
                //     case "failed_to_update_core_waybill_related_column":
                //         payload.status = "Failure"
                //         break
                //     case 'scan_action_description_is_empty':
                //     case 'failed_to_create_core_waybill':
                //         payload.status = "Failure"
                //         break
                //     case 'core_waybill_not_found':
                //         payload.errors.push("查無單號")
                //         payload.status = "Failure"
                //         break
                //     case 'available_partition_not_found':
                //         payload.errors.push("無可用號碼區間")
                //         payload.status = "Failure"
                //         break
                //     case 'create_core_waybill':
                //         payload.status = "Pending"
                //         payload.is_waiting_user_action = true
                //         break
                //     case 'core_waybill_related_column_is_empty':
                //         payload.status = "Pending"
                //         payload.is_waiting_user_action = true
                //         break
                // }
                // await context.dispatch("set_local_storage_job")
                return Promise.reject(e)
            }

            return Promise.resolve()
        },
        perform_init(context, payload) {
            if (!payload.number) {
                payload.errors.push("請輸入號碼")
                return Promise.reject("no_input_number")
            }

            // 隱藏 設定區
            context.state.is_setting = false
            context.state.current_job = payload

            // 清除 current_core_waybill
            payload.core_waybill = {}
            payload.core_waybill_scope = ""
            context.state.current_core_waybill = {}
            context.state.current_core_waybill_scope = ""

            // 清除 必填欄位
            context.state.actions_core_waybill_related_columns = {}

            // 清除 分撥
            context.dispatch("clear_distributed_to")

            return Promise.resolve()
        },
        create_fake_core_waybill(context, payload) {
            let basic_core_waybill = {
                number: payload.number,
                tracking_number: payload.number,
                identity: `${Date.now()}_is_fake_identity`,
                note: `This is fake waybill.`
            }
            payload.core_waybill = basic_core_waybill
            payload.core_waybill_scope = "fake"
            context.state.current_core_waybill = payload.core_waybill
            context.state.current_core_waybill_scope = "fake"
            return Promise.resolve()
        },
        search_core_waybill(context, payload) {
            let rest_url = new RestUrl(context.rootState.provider.routes.api_v1_provider_core_waybills_search)
            let url = rest_url.parse(
                {}, "?latest_status_scope=operator"
            )

            return axios.post(
                url,
                {
                    number: payload.number
                },
                {
                    headers: { Authorization: localStorage.getItem("authentication_token") }
                }
            ).then(async response => {
                console.log(response.data)
                if (response.data.status == "success") {
                    if (!response.data.core_waybill.pieces) {
                        response.data.core_waybill.pieces = 1
                    }

                    payload.core_waybill = response.data.core_waybill
                    payload.core_waybill_scope = response.data.scope
                    context.state.current_core_waybill = payload.core_waybill
                    context.state.current_core_waybill_scope = response.data.scope
                } else {
                    switch (response.data.errors) {
                        case "CoreWaybill not found.":
                        case "Available partition not found.":
                        case "Partition not found":
                            return Promise.reject("core_waybill_not_found")
                            break
                        default:
                            return Promise.reject(response.data.errors)
                    }

                }
            })
        },
        async reload_core_waybill(context, payload) {
            if (context.state.settings.is_reload_core_waybill_mode) {
                await new Promise(resolve => {
                    context.state.settings.is_auto_print_label_mode = true;
                    resolve()
                })
                await context.dispatch("search_core_waybill", payload)
                await new Promise(resolve => {
                    context.state.settings.is_auto_print_label_mode = false;
                    resolve()
                })
            }
        },
        async snap_webcam(context, payload) {
            await new Promise(resolve => {
                WebCamera.snap(data_uri => {
                    fetch(data_uri)
                    .then(res => res.blob())
                    .then(blob => {
                        let file = new File([blob], "webcam.jpeg");
                        context.commit('add_webcam_snap', {
                            id: context.state.webcam_snaps.slice(-1).pop() ? context.state.webcam_snaps.slice(-1).pop().id + 1:1,
                            snap_file: file,
                            core_waybill_identity: context.state.current_core_waybill.identity,
                            status: "Pending",
                            job_id: payload.id
                        })
                        resolve()
                    });
                });
                for (let pending_webcam_snap of _.filter(context.state.webcam_snaps, (webcam_snap) => {
                    return webcam_snap.status == "Pending" || webcam_snap.status == "Error"
                })) {
                    context.dispatch("upload_webcam_snap", pending_webcam_snap);
                }
            });
            // WebCamera.snap(data_uri => {
            //     let form_data = new FormData()
            //     fetch(data_uri)
            //         .then(res => res.blob())
            //         .then(blob => {
            //             let file = new File([blob], "webcam.jpeg");
            //             form_data.append('file', file);
            //         });
            //     fetch(file_upload_url, {
            //         method: 'POST',
            //         body: form_data
            //     }).then(response => {
            //        if (response.data.link) {
            //            context.dispatch('provider/scanner_module/update_core_waybill', {
            //                goods_file_url: response.data.link
            //            });
            //        }
            //     }).catch(error => {
            //         console.log(error);
            //     })
            // })
        },
        upload_webcam_snap(context, payload) {
            payload.status = "Processing"
            let file_upload_url = new RestUrl(
                "https://air.formosaas.com/api/v1/:app_id/cloud/:access_token/:identity/bucket/:bucket_identity/upload"
            ).parse(
                {
                    "app_id": context.rootState.provider.node.air_service.air_app_id,
                    "access_token": context.rootState.provider.node.air_service.air_access_token,
                    "identity": context.rootState.provider.node.air_service.air_identity,
                    "bucket_identity": context.rootState.provider.node.air_service.air_bucket_identity,
                    "air_authorization": context.rootState.provider.node.air_service.air_authorization
                },
                "?authorization=" + context.rootState.provider.node.air_service.air_authorization + "&is_froala=true"
            );
            let form_data = new FormData()
            form_data.append('file', payload.snap_file);
            return axios.post(
                file_upload_url,
                form_data
            ).then(response => {
                if (response.data.link) {
                    payload.status = "Success"
                    context.dispatch('update_core_waybill', {
                        core_waybill_identity: payload.core_waybill_identity,
                        goods_file_url: response.data.link
                    });
                    for (let pending_webcam_snap of _.filter(context.state.webcam_snaps, (webcam_snap) => {
                        return webcam_snap.status == "Pending" || webcam_snap.status == "Error"
                    })) {
                        context.dispatch("upload_webcam_snap", pending_webcam_snap);
                    }
                }
            }).catch(error => {
                payload.status = "Error"
                console.log(error);
            })
        },
        handle_search_result(context, payload) {
            if (context.state.current_core_waybill_scope == 'new') {
                return Promise.reject("create_core_waybill")
            }

            if (
                _.findLast(context.state.core_waybills, (core_waybill) => {
                    return core_waybill.identity == payload.core_waybill.identity
                })
            ) {
                _.remove(context.state.core_waybills, {
                    identity: payload.core_waybill.identity
                })
            }
            context.state.core_waybills.push(payload.core_waybill)
            if(context.state.core_waybills.length >= 10) {
                context.state.core_waybills.shift()
            }

            return Promise.resolve()
        },
        async speech_consignee_info(context, payload) {
            if (!context.state.settings.is_speech_mode) {
                return Promise.resolve()
            }
            try {
                let sentence = ""
                let index = 0
                for(let field_name of ['consignee_company_name', 'consignee_name']) {
                    if (context.state.current_core_waybill[field_name]) {
                        if (sentence && index != 0) {
                            sentence += ","
                        }
                        sentence += context.state.current_core_waybill[field_name]
                    }
                    index++
                }
                if (sentence) {
                    await new Promise(resolve => {
                        let speech = new Speech({
                            onend: () => resolve(),
                            oncancel: () => resolve()
                        })
                        speech.cancel()

                        if (!isNaN(sentence)) {
                            speech.speak(sentence.split("").join(" "))
                        } else {
                            speech.speak(sentence)
                        }
                    })
                }
            } catch (e) {
                console.log(e)
            } finally {
                return Promise.resolve()
            }
        },
        async search_or_create_core_waybill(context, payload) {
            try {
                if (!payload.partition.identity) {
                    return Promise.reject("partition_not_found")
                }
                await context.dispatch("search_core_waybill", payload)
            } catch (e) {
                switch (e) {
                    case "core_waybill_not_found":
                        let rest_url = new RestUrl(context.rootState.provider.routes.api_v1_provider_core_waybills_create)
                        let url = rest_url.parse()
                        await axios.post(
                            url,
                            {
                                partition_identity: payload.partition.identity,
                                original_number: payload.original_number,
                                is_used: true
                            },
                            {
                                headers: { Authorization: localStorage.getItem("authentication_token") }
                            }
                        ).then(response => {
                            console.log(response)
                            if (response.data.status == "success") {
                                payload.core_waybill = response.data.core_waybill
                                context.state.current_core_waybill = payload.core_waybill
                            } else {
                                Promise.reject("failed_to_create_core_waybill")
                            }
                        })
                        await context.dispatch("search_core_waybill", payload)
                        break
                }
            }
        },
        // 確認 運單 使否需要跳出必填欄位的 Alert 視窗
        check_core_waybill_related_columns(context, payload) {
            console.log("current_core_waybill_need_related_columns: ", context.getters.current_core_waybill_need_related_columns.length)

            if (context.getters.current_core_waybill_need_related_columns.length) {
                return Promise.reject("core_waybill_related_column_is_empty")
            }

            if (context.state.settings.is_quick_corewaybill_related_columns_mode) {
                context.commit(
                    'set_actions_core_waybill_related_columns',
                    context.state.quick_core_waybill_related_columns
                )
            }
            return Promise.resolve()
        },
        instantiate_scan_action_prototype(context, payload) {
            let is_can_instantiate_scan_action = true
            let params = {location: (context.rootState.provider.current_staff.station || {}).name}
            let rest_url = new RestUrl(context.rootState.provider.routes.api_v1_provider_scan_action_prototype_instantiate)
            let url = rest_url.parse(
                {
                    'barcode': payload.scan_action_prototype.barcode,
                    'core_waybill_identity': payload.core_waybill.identity,
                }, ""
            )

            // 貨況備註
            // description
            // 是作業模式 + 須填貨況備註 + 沒有填備註
            if (
                context.state.settings.is_scan_action_mode &&
                context.getters.current_scan_action_prototype_description_required_scope.length &&
                !context.state.scan_action_description
            ) {
                return Promise.reject("scan_action_description_is_empty")
            }

            if (context.state.scan_action_description) {
                params.description = context.state.scan_action_description
            }

            /*
             * ========================================================================
             * 多件一單模式
             * ========================================================================
            **/
            let core_waybill_counter = _.findLast(context.state.core_waybill_counters, (counter) => {
                return counter.identity == context.state.current_core_waybill.identity
            })
            let core_waybill_counter_index = _.findIndex(context.state.core_waybill_counters, {
                identity: context.state.current_core_waybill.identity
            })
            if (
                context.state.settings.is_core_waybill_pieces_mode &&
                context.state.current_core_waybill.pieces != 1
            ) {
                try {
                    // 第一次初始化
                    if (core_waybill_counter_index == '-1') {
                        core_waybill_counter_index = 0
                        core_waybill_counter = {
                            number: context.state.current_core_waybill.number,
                            identity: context.state.current_core_waybill.identity,
                            core_waybill_pieces: context.state.current_core_waybill.pieces,
                            current_core_waybill_counter: 1,
                        }
                        context.state.core_waybill_counters.push(core_waybill_counter)
                        throw false
                    }
                    // 多件一單模式符合時
                    core_waybill_counter.current_core_waybill_counter +=1
                    if (core_waybill_counter.current_core_waybill_counter >= context.state.current_core_waybill.pieces) {
                    } else {
                        throw false
                    }
                } catch (boolean) {
                    is_can_instantiate_scan_action = boolean
                }

                // 更新 core_waybill_counters
                context.state.core_waybill_counters.splice(core_waybill_counter_index, 1, core_waybill_counter)
                context.dispatch("set_local_storage_core_waybill_counter")

                payload.core_waybill_pieces = core_waybill_counter.core_waybill_pieces
                payload.current_core_waybill_counter = core_waybill_counter.current_core_waybill_counter
                payload.is_waiting_instantiate_scan_action = true
            }

            if (is_can_instantiate_scan_action) {
                return axios.post(
                    url,
                    params,
                    {
                        headers: { Authorization: localStorage.getItem("authentication_token") }
                    }
                ).then(response => {
                    context.state.scan_action_description = ""

                    if (core_waybill_counter_index != '-1') {
                        _.remove(context.state.core_waybill_counters, (counter) => {
                            return counter.identity == context.state.current_core_waybill.identity
                        })
                    }

                    if (response.data.status == "success") {

                    } else {
                        payload.status = "Failure"
                        for (let key of Object.keys(response.data.errors)) {
                            for (let error of response.data.errors[key]) {
                                payload.errors.push(error)
                            }
                        }
                        return Promise.reject("failed_to_instantiate_scan_action_prototype")
                    }
                })
            }
        },
        add_core_waybills_to_operation(context, payload) {
            if (context.rootState.provider.current_staff_operation.identity) {
                let url = new RestUrl(context.rootState.provider.routes.api_v1_provider_operation_add_core_waybills).parse(
                    {
                        "operation_identity": context.rootState.provider.current_staff_operation.identity,
                    },
                    ""
                )
                let params = {
                    core_waybill_identities: [payload.core_waybill.identity]
                }

                return axios.post(url, params, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        if (
                            !_.includes(response.data.success_core_waybill_identities, (identity) => {
                                return identity == payload.core_waybill.identity
                            })
                        ) {
                            payload.errors.push("Failed to add to operation")
                        }
                    } else if (response.data.status == "failure") {
                        payload.errors.push(response.data.errors)
                        return Promise.reject("core_waybill_not_found")
                    }
                })
            }
        },
        fetch_statuses(context, payload) {
            let rest_url = new RestUrl(context.rootState.provider.routes.api_v1_provider_core_waybill_statuses)
            let url = rest_url.parse(
                {
                    core_waybill_identity: context.state.current_core_waybill.identity
                },
                ""
            )

            return axios.get(
                url,
                {
                    headers: { Authorization: localStorage.getItem("authentication_token") }
                }
            ).then(response => {
                if (response.data.status == "success") {
                    context.state.current_core_waybill.latest_status = response.data.latest_status
                    context.state.current_core_waybill.statuses = response.data.statuses
                } else {
                    return Promise.reject("failed_to_fetch_core_waybill_statuses")
                }
            })
        },
        distribute(context, payload) {
            if (
                context.state.settings.is_distributed_to_mode &&
                payload.station.identity
            ) {
                let rest_url = new RestUrl(context.rootState.provider.routes.api_v1_provider_station_distribute)
                let url = rest_url.parse(
                    {
                        station_identity: payload.station.identity,
                        core_waybill_identity: context.state.current_core_waybill.identity,
                    },""
                )

                return axios.post(
                    url,
                    {},
                    {
                        headers: { Authorization: localStorage.getItem("authentication_token") }
                    }
                ).then(response => {
                    // 分撥 response
                    context.state.distributed_to = response.data.distributed_to
                        ? response.data.distributed_to : {}

                })
            }
        },
        // 包裝
        async pack(context, payload) {
            try {
                context.state.package_message = {status: "", content: ""}

                // 非包裝模式
                if (!context.state.settings.is_package_mode) {
                    return Promise.resolve()
                }

                let current_pack_taget_parent_material = context.getters.current_pack_taget_parent_material
                let current_pack_taget_material = context.getters.current_pack_taget_material

                // 無 包材
                if (!current_pack_taget_parent_material.class_name) {
                    throw "請選擇包材"
                }

                // 無 包裝目標
                if (!current_pack_taget_material.class_name) {
                    throw "請選擇包裝目標"
                }

                // 掃到第一單
                // (包裝內 沒有 包任意物品 || 包裝內 沒有 包材)
                if (
                    !context.state.package.core_waybills.length &&
                    !context.state.package.parent_core_waybill.identity
                ) {

                    // 當前物料名稱 == 選定包材
                    if (payload.core_waybill.material.class_name == current_pack_taget_parent_material.class_name) {
                        await context.commit('set_package', payload.core_waybill)
                        return Promise.resolve()

                    // 當前物料名稱 != 選定包材
                    } else {
                        // 當前物料名稱 != 包裝目標
                        if (payload.core_waybill.material.class_name == current_pack_taget_material.class_name) {
                            throw "請掃" + current_pack_taget_parent_material.name
                        }

                    }
                }

                // 當前core_waybill != 包裝內的 包材
                if (payload.core_waybill.identity != context.state.package.parent_core_waybill.identity) {

                    // 當前物料名稱 == 選定包材 &&
                    // 當前物料名稱 != 包裝目標
                        // 有可能運單包運單, 子單包子單
                    if (
                        payload.core_waybill.material.class_name == current_pack_taget_parent_material.class_name &&
                        payload.core_waybill.material.class_name != current_pack_taget_material.class_name
                    ) {

                        // 有包任何內容物時 送出 request
                        if (context.state.package.core_waybills.length) {
                            await context.dispatch("submit_package", payload)
                        }
                        await context.commit('set_package', payload.core_waybill)

                    } else {
                        // 當前物料名稱 == 包裝目標
                        if (payload.core_waybill.material.class_name == current_pack_taget_material.class_name) {
                            if (context.state.package.core_waybills.length > 0) {
                                let different_core_waybill = _.findLast(context.state.package.core_waybills, core_waybill => {
                                    return core_waybill.consignee_name != payload.core_waybill.consignee_name
                                });

                                if (different_core_waybill && context.state.package.difference_log.indexOf(different_core_waybill.identity) == -1 ) {
                                    context.state.package.difference_log.push(different_core_waybill.identity);
                                    throw "同包裝不同收件人，再次掃描可強制加入"
                                }
                            }
                            context.commit('push_package', payload.core_waybill);
                        } else {
                            if (!context.state.package.core_waybills.length) {
                                throw "請掃" + current_pack_taget_parent_material.name
                            }
                            throw "請掃" + current_pack_taget_parent_material.name + "或" + current_pack_taget_material.name
                        }
                    }

                }

                return Promise.resolve()

            } catch (error) {
                context.state.package_message = {
                    status: "failure",
                    content: "無法包裝[" + payload.core_waybill.material.name + "]，" + error
                }
                return Promise.reject()
            }
        },
        // 拆包
        async unpack(context, payload) {
            if (context.state.settings.is_unpackage_mode) {
                await context.commit('set_package', payload.core_waybill)
                await context.dispatch("submit_package", payload)
            }
            return Promise.resolve()
        },
        submit_package(context, payload) {
            let url = new RestUrl(context.rootState.provider.routes.api_v1_provider_core_waybills_pack).parse(
                {},
                "?need_merge=" + context.state.settings.is_pack_need_merge_mode
            )

            let params = {
                // 代表上層包裝用的core_waybill, 必填欄位
                parent_core_waybill_identity: context.state.package.parent_core_waybill.identity,

                // 代表上層包裝用的core_waybill, 當你是運單包子單時此參數必填
                source_core_waybill_identity: context.state.settings.is_pack_need_source_mode ? context.state.package.source_core_waybill_identity:null,
                core_waybill_identities: context.state.settings.is_unpackage_mode ? []:_.map(context.state.package.core_waybills, "identity")
            }

            return axios.post(
                url,
                params,
                {
                    headers: { Authorization: localStorage.getItem("authentication_token") }
                }
            ).then(response => {
                if (response.data.status == "success") {
                    context.state.package_response_history.push(
                        // Object merage
                        _.assign(response.data, {
                            id: context.state.package_response_history.slice(-1).pop() ? context.state.jobs.slice(-1).pop().id + 1:1,
                            is_setting_is_package_mode: context.state.settings.is_package_mode
                        })
                    )
                } else {
                    payload.package_response = response.data
                    payload.errors.push("包裝失敗，"+response.data.errors)
                    return Promise.reject("包裝失敗，"+response.data.errors)
                }
            })

        },
        set_local_storage_core_waybill_counter(context, payload) {
            let string_array = []
            _.forEach(context.state.core_waybill_counters, (job) => {
                string_array.push(JSON.stringify(job))
            })
            localStorage.setItem('scanner_core_waybill_counters',string_array.toString())
        },
        set_local_storage_job(context, payload) {
            let string_array = []
            _.forEach(context.state.jobs, (job) => {
                let item = $.extend(true, {}, job)
                delete item.core_waybill
                string_array.push(JSON.stringify(item))
                if(string_array.length >= 31){
                    string_array.shift()
                }
            })
            localStorage.setItem('scanner_jobs',string_array.toString())
        },
        clear_core_waybill_counter(context, payload) {
            localStorage.setItem('scanner_core_waybill_counters', "")
            context.state.core_waybill_counters = []
        },
        clear_job(context, payload) {
            localStorage.setItem('scanner_jobs', "")
            context.state.jobs = []
        },
        clear_distributed_to(context, payload) {
            context.state.distributed_to = {}
        },
        set_current_operation(context, payload) {
            context.state.current_operation = payload
        },
        actions_core_waybill_related_column(context, payload) {
            context.state.actions_core_waybill_related_columns[payload.name] = payload.value
        },
    },
    mutations: {
        update_current_job(state, payload) {
            _.merge(state.current_job, payload)
        },
        push_package(state, payload) {
            // state.package.core_waybill_identities.push(payload.identity)
            if (!_.findLast(state.package.core_waybills, payload)) {
                state.package.core_waybills.push(payload)
            }
        },
        set_package(state, payload) {
            state.package = {
                parent_core_waybill: payload,
                core_waybill_identities: [],
                core_waybills: [],
                source_core_waybill_identity: payload.identity,
                difference_log: []
            }
        },
        set_webcam_snap_interval(state, payload) {
            state.webcam_snap_interval = payload
        },
        clear_webcam_snap_interval(state, payload) {
            clearInterval(state.webcam_snap_interval)
            state.webcam_snap_interval = null
        },
        set_actions_core_waybill_related_columns(state, payload) {
            state.actions_core_waybill_related_columns = payload
        },
        set_scan_action_prototypes(state, payload) {
            state.scan_action_prototypes = payload
        },
        set_current_partition(state, payload) {
            state.current_partition = payload
        },
        set_materials(state, payload) {
            state.materials = payload
        },
        set_current_weight(state, payload) {
            state.current_weight = payload
        },
        set_partitions(state, payload) {
            state.partitions = payload
        },
        add_job(state, payload) {
            state.jobs.push(payload)
        },
        update_actions_core_waybill_related_column(state, payload) {
            state.actions_core_waybill_related_columns[payload.related_column_name] = payload.value
        },
        add_webcam_snap(state, payload) {
            state.webcam_snaps.push(payload)
        },
    }
}

export default store
